import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import { Header } from "../../components/Header";
import DiningRoom from "../../components/icons/NavIcons/DiningRoom";
import Cafe from "../../components/icons/NavIcons/Cafe";

const DiningPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash2 diningPage">
        <Header />
        <div className="page-header">On Site Dining</div>
        <div className="text-blocks">
          <div className="std-text">
            Use InfoGenesis Meal Plan Integration to offer your residents the
            convenience of cashless tender. Create unique accounts for
            residents, employees, resident account charge or any other type of charge.{'\n\n'}

            Establish multiple types of Meal Plan accounts for resident and
            staff through gift cards, payroll deductions, stored value and VIP
            cards.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "On-site Dining", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="dining-map">
          <div className="dining-room">
            <DiningRoom
              onClick={() => {
                _logEvent("click", "On-site Dining", "Dining Room");
                addFlow("Dining Room");
                navigate("dining-room", { relative: "path" });
              }}
            />
          </div>
          <div className="kitchen">
            <Kitchen
              onClick={() => {
                _logEvent("click", "On-site Dining", "Kitchen");
                addFlow("Kitchen");
                navigate("kitchen", { relative: "path" });
              }}
            />
          </div>
          <div className="cafe">
            <Cafe
              onClick={() => {
                _logEvent("click", "On-site Dining", "Cafe");
                addFlow("Cafe");
                navigate("cafe", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default DiningPage;